/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_CliInputs */

const en_directory_agent_readiness_check_cli = /** @type {(inputs: Directory_Agent_Readiness_Check_CliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI`)
};

const zh_directory_agent_readiness_check_cli = /** @type {(inputs: Directory_Agent_Readiness_Check_CliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命令行工具`)
};

/**
* | output |
* | --- |
* | "CLI" |
*
* @param {Directory_Agent_Readiness_Check_CliInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_cli = /** @type {((inputs?: Directory_Agent_Readiness_Check_CliInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_CliInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_cli(inputs)
	return zh_directory_agent_readiness_check_cli(inputs)
});
export { directory_agent_readiness_check_cli as "directory.agent_readiness.check.cli" }